/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { PropertyResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface PropertyUserServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get user properties
     * 
     * @param userId 
     */
    getUserProperties(userId?: string, extraHttpRequestParams?: any): Observable<Array<PropertyResource>>;

}
